/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Scope_Datasets_TitleInputs */



/**
* | output |
* | --- |
* | "Which datasets?" |
*
* @param {Agent_Scope_Datasets_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_scope_datasets_title = /** @type {((inputs?: Agent_Scope_Datasets_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Scope_Datasets_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welche Datensätze?")
	return /** @type {LocalizedString} */ ("Which datasets?")
});